<template>
  <div id="dashboard">
    <filters
      :monthRange="true"
      :region="true"
      @refresh="setParams"
      :dataSource="$t('filter.sourceAirdna')"
    />
    <loading v-if="loading" />
    <b-row class="mt-3" v-else>
      <b-col>
        <b-row>
          <b-col md="6" sm="12">
            <ChartCard
              :title="this.$t('airdna.listings_by_property_type')"
              v-if="objectsByType.data[0].data"
              :data="objectsByType.data"
              :chartType="objectsByType.type"
              :options="objectsByType.chartOptions"
            />
          </b-col>
          <b-col md="6" sm="12">
            <ChartCard
              :title="this.$t('airdna.adr_by_property_type')"
              v-if="adrByType.data[0].data"
              :data="adrByType.data"
              :chartType="adrByType.type"
              :options="adrByType.chartOptions"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col md="6" sm="12">
            <ChartCard
              :title="this.$t('airdna.listings_by_property_size')"
              v-if="objectsBySize.data[0].data"
              :data="objectsBySize.data"
              :chartType="objectsBySize.type"
              :options="objectsBySize.chartOptions"
            />
          </b-col>
          <b-col md="6" sm="12">
            <ChartCard
              :title="this.$t('airdna.adr_by_property_size')"
              v-if="adrBySize.data[0].data"
              :data="adrBySize.data"
              :chartType="adrBySize.type"
              :options="adrBySize.chartOptions"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <PointsMap v-if="this.map.data" :data="this.map.data" :key="this.map.data[0].id" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AirdnaMixins from "@/mixins/api/airdna";
import ChartCard from "@/components/dashboard/ChartCard";
import PointsMap from "@/components/dashboard/PointsMap";

export default {
  name: "AirdnaOffer",
  mixins: [AirdnaMixins],
  components: {
    ChartCard,
    PointsMap,
  },
  data() {
    return {
      loading: true,
      map: {
        data: null,
      },
      objectsByType: {
        data: [
          {
            name: this.$t("legends.actual_year"),
            data: null,
          },
        ],
        type: "bar",
        chartOptions: {
          chart: {
            id: "airdna_listings_type",
            type: "bar",
            toolbar: {
              show: false,
              tools: {
                download: false,
              },
            },
          },
          xaxis: {
            categories: null,
            title: {
              text: this.$t("legends.listings"),
            },
          },
          yaxis: {
            title: {
              text: this.$t("legends.listingsType"),
            },
          },
          colors: ["#f9af05", "#fdd77e"],
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          dataLabels: {
            enabledOnSeries: [0],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
          },
        },
      },
      adrByType: {
        data: [
          {
            name: this.$t("legends.actual_year"),
            data: null,
          },
        ],
        type: "bar",
        chartOptions: {
          chart: {
            id: "airdna_adr_type",
            type: "bar",
            toolbar: {
              show: false,
              tools: {
                download: false,
              },
            },
          },
          xaxis: {
            categories: null,
            title: {
              text: this.$t("legends.adr"),
            },
          },
          yaxis: {
            title: {
              text: this.$t("legends.listingsType"),
            },
          },
          colors: ["#f9af05", "#fdd77e"],
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          dataLabels: {
            enabledOnSeries: [0],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
            formatter: function (val) {
              return val.toLocaleString("fr-CH", { maximumFractionDigits: 0 });
            },
          },
        },
      },
      objectsBySize: {
        data: [
          {
            name: this.$t("legends.actual_year"),
            data: null,
          },
        ],
        type: "bar",
        chartOptions: {
          chart: {
            id: "airdna_listings_size",
            type: "bar",
            toolbar: {
              show: false,
              tools: {
                download: false,
              },
            },
          },
          xaxis: {
            categories: null,
            title: {
              text: this.$t("legends.listingsSize"),
            },
          },
          yaxis: {
            title: {
              text: this.$t("legends.listings"),
            },
          },
          colors: ["#f9af05", "#fdd77e"],
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          dataLabels: {
            enabledOnSeries: [0],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
          },
        },
      },
      adrBySize: {
        data: [
          {
            name: this.$t("legends.actual_year"),
            data: null,
          },
        ],
        type: "bar",
        chartOptions: {
          chart: {
            id: "airdna_adr_size",
            type: "bar",
            toolbar: {
              show: false,
              tools: {
                download: false,
              },
            },
          },
          xaxis: {
            categories: null,
            title: {
              text: this.$t("legends.listingsSize"),
            },
            labels: {
              formatter: (val) => {
                return val.toLocaleString("fr-CH", {
                  maximumFractionDigits: 0,
                });
              },
            },
          },
          yaxis: {
            title: {
              text: this.$t("legends.adr"),
            },
            labels: {
              formatter: (val) => {
                return val.toLocaleString("fr-CH", {
                  maximumFractionDigits: 0,
                });
              },
            },
          },
          colors: ["#f9af05", "#fdd77e"],
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          dataLabels: {
            enabledOnSeries: [0],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
            formatter: function (val) {
              return val.toLocaleString("fr-CH", { maximumFractionDigits: 0 });
            },
          },
        },
      },
    };
  },
  methods: {
    setParams(newParams) {
      this.params = newParams;
      this.refreshData();
    },
  },
};
</script>
